import { render, staticRenderFns } from "./Productization.vue?vue&type=template&id=0b53b778&"
import script from "./Productization.vue?vue&type=script&lang=js&"
export * from "./Productization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports